import { render } from "./DefaultSwiper.vue?vue&type=template&id=465eb4ae&scoped=true"
import script from "./DefaultSwiper.vue?vue&type=script&lang=js"
export * from "./DefaultSwiper.vue?vue&type=script&lang=js"

import "./DefaultSwiper.vue?vue&type=style&index=0&id=465eb4ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465eb4ae"]])

export default __exports__